(function($) {
    init();

    function init() {
        handleHamburger();
        handleLazyLoading();
        handlePlaceholders();
        langSwitcher();
    }

    // Lazy loading images
    function handleLazyLoading() {
        if ('loading' in HTMLImageElement.prototype) {
            const images = document.querySelectorAll('img[loading="lazy"]');
            images.forEach(img => {
                if (img.dataset.src) {
                    img.src = img.dataset.src;
                }
            });
        } else {
            const script = document.createElement('script');
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.1.2/lazysizes.min.js';
            script.async = true;
            script.onerror = () => console.warn('LazySizes failed to load');
            document.body.appendChild(script);
        }
    }

    // Placeholder logic
    function handlePlaceholders() {
        $('input, textarea').on('focus', function() {
            const $this = $(this);
            $this.data('placeholder', $this.attr('placeholder')).attr('placeholder', '');
        }).on('blur', function() {
            const $this = $(this);
            $this.attr('placeholder', $this.data('placeholder'));
        });
    }

    // Hamburger menu toggle
    function handleHamburger() {
        $('.hamburger').on('click', function() {
            $('body, html').toggleClass('menu-open');
            $('.navbar').addClass('navbar-scrolled');
            $('.navbar__fixed').toggleClass('navbar__fixed-mobile');
            $('.mobile-overlay').stop().delay(300).toggleClass('open-m');
            $('.hamburger').toggleClass('hamburger-active');
        });

        $('.mobile-overlay ul li').on('click', function() {
            $('body, html').removeClass('menu-open');
            $('.navbar__fixed').removeClass('navbar__fixed-mobile');
            $('.mobile-overlay').stop().delay(300).removeClass('open-m');
            $('.hamburger').removeClass('hamburger-active');
        });
    }

    // LANG WHITCHER
    function langSwitcher() {
        const switcher = document.querySelector('.lang-switcher');
    const button = switcher?.querySelector('.lang-button');

    if (button) {
        button.addEventListener('click', function () {
            switcher.classList.toggle('open');
        });

        document.addEventListener('click', function (e) {
            if (!switcher.contains(e.target)) {
                switcher.classList.remove('open');
            }
        });
    }
    }

})(jQuery);
